(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("learningPathVersion", {
        templateUrl: "app/learningPaths/version/learningPathVersion.component.html",
        controller: ["cropPictureService", "learningPathVersionViewModelResource", "learningPathVersionResource", "learningPathResource", "messageService", "frameworkService", "$localStorage", "$location", "$timeout", "$rootScope", "$scope", "$state", "$stateParams", "$translate", "$uibModal", "_", LearningPathVersionCtrl],
        controllerAs: "vm"
    });
    function LearningPathVersionCtrl(cropPictureService, learningPathVersionViewModelResource, learningPathVersionResource, learningPathResource, messageService, frameworkService, $localStorage, $location, $timeout, $rootScope, $scope, $state, $stateParams, $translate, $uibModal, _) {
        var vm = this;
        vm.number = $stateParams.number;
        vm.currentPage = 1;
        vm.version = $stateParams.version; //still need this
        //if sent here from edit learning item (list of paths)
        if ($state.current.name === "main.learningItems.learningPathAndVersion") {
            $state.go("main.learningItems.learningPathVersion", { number: vm.number, version: vm.version }, {
                location: 'replace'
            });
            return;
        }
        vm.isNewVersion = false;
        vm.isReadOnly = true;
        vm.reloadingPath = false;
        vm.learningPathVersion = {};
        vm.loading = true;
        vm.frameworkData = frameworkService.data;
        vm.loadingPicture = false;
        vm.canPublish = false;
        vm.openBadgesEnabled = vm.frameworkData.tenantFeatures.openBadges;
        //vm.tenantUrl = $localStorage.tenantSettings.url + "." + $localStorage.tenantSettings.domain;
        $scope.$watch(function () {
            return vm.learningPathVersion.items;
        }, function () {
            vm.updateCanPublish();
        }, true);
        loadVersion(vm.version);
        function loadVersion(version) {
            if (version) {
                learningPathVersionViewModelResource.get({ number: vm.number, version: version }, function (data) {
                    loadData(data);
                }, function (error) {
                    messageService.error(error);
                });
            }
            else {
                learningPathVersionViewModelResource.get({ number: vm.number }, function (data) {
                    loadData(data);
                }, function (error) {
                    messageService.error(error);
                });
            }
        }
        function loadData(data) {
            vm.version = data.version;
            vm.maxVersion = data.maxVersion;
            vm.currentVersion = data.version;
            vm.isReadOnly = data.assignedCount > 0 || data.isPublished;
            vm.reloadingPath = true;
            vm.learningPathVersion = data;
            vm.learningPathName = vm.learningPathVersion.learningPathName + " " + (vm.learningPathVersion.versionName ? vm.learningPathVersion.versionName : "");
            if (vm.frameworkData.tenantFeatures.catalogVisible) {
                vm.showCreateProduct = !data.slug;
                vm.showEditProduct = data.slug;
            }
            if (vm.learningPathVersion.items)
                vm.learningPathVersion.items.sort(function (a, b) {
                    return a.order - b.order;
                });
            vm.pristineItems = angular.copy(vm.learningPathVersion.items);
            vm.isInformationEnabledOriginal = vm.learningPathVersion.isInformationEnabled;
            //Needs to wait the destruction of the object to recreate it.
            $timeout(function () {
                vm.reloadingPath = false;
            });
            vm.loading = false;
        }
        vm.versionChanged = function () {
            loadVersion(vm.currentVersion);
        };
        vm.pathSortableOptions = {
            placeholder: "place-item-drag",
            "ui-floating": true,
            forcePlaceholderSize: true,
            tolerance: "pointer",
            cancel: ".jumbotron, select",
            dropOnEmpty: true,
            stop: function () {
                vm.learningPathVersion.items = recalculateOrder(vm.learningPathVersion.items);
            }
        };
        //Start Modal Section
        vm.openAddItemModal = function () {
            if (vm.addItemModelIsOpen)
                return;
            var modalInstance = $uibModal.open({
                templateUrl: "app/learningPaths/modals/addItemsModalView.html",
                controller: "AddItemsModalCtrl as vm",
                size: "lg",
                scope: $scope,
                resolve: {}
            });
            vm.addItemModelIsOpen = true;
            modalInstance.result.then(function (list) {
                $scope.addItems(list);
            }).catch(angular.noop);
            modalInstance.result.finally(function () {
                vm.addItemModelIsOpen = false;
            }).catch(angular.noop);
            $scope.addItems = function (list) {
                angular.forEach(list, function (item) {
                    item.requiredForRecognition = true;
                });
                vm.learningPathVersion.items = recalculateOrder(_.union(vm.learningPathVersion.items, list));
                return vm.learningPathVersion.items;
            };
        };
        //End Modal Section
        vm.translatePath = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/learningPaths/modals/translatePathModalView.html",
                controller: "TranslatePathModalCtrl as vm",
                size: "lg",
                scope: $scope
            });
            modalInstance.result.then(function (result) {
                var item = _.find(result.pathLocalizations, function (pathLocalization) {
                    return pathLocalization.localizationId.toString() === $localStorage.currentLocalizationId.toString();
                });
                vm.learningPathVersion.learningPathName = item.name;
                vm.learningPathName = vm.learningPathVersion.learningPathName + " " + (vm.learningPathVersion.versionName ? vm.learningPathVersion.versionName : "");
            }).catch(angular.noop);
        };
        vm.translateVersionName = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/learningPaths/modals/translateVersionNameModalView.html",
                controller: "TranslateVersionNameModalCtrl as vm",
                size: "lg",
                resolve: {
                    data: function () {
                        return { version: vm.version };
                    }
                }
            });
            modalInstance.result.then(function (result) {
                var item = _.find(result.learningPathVersionLocalizations, function (pathVersionLocalization) {
                    return pathVersionLocalization.localizationId.toString() === $localStorage.currentLocalizationId.toString();
                });
                vm.learningPathVersion.versionName = item.name;
                vm.learningPathName = vm.learningPathVersion.learningPathName + " " + (vm.learningPathVersion.versionName ? vm.learningPathVersion.versionName : "");
            }).catch(angular.noop);
        };
        vm.openIconModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/learningPaths/modals/selectIconsModalView.html",
                controller: "SelectIconsModalCtrl as vm",
                resolve: {
                    activeIcon: function () {
                        return vm.learningPathVersion.iconCssClass;
                    }
                }
            });
            modalInstance.result.then(function (icon) {
                vm.saveIcon = { number: vm.number, iconCssClass: icon.className, rowVersion: vm.learningPathVersion.rowVersion };
                learningPathResource.savePathIcon({ number: vm.number }, vm.saveIcon, function (result) {
                    if (result.value)
                        vm.learningPathVersion.iconCssClass = icon.className;
                    else
                        messageService.error("common.genericError");
                }, function (errorData) {
                    messageService.error(errorData);
                });
            }).catch(angular.noop);
        };
        //EXAMPLE - How to use Crop Service
        vm.openPictureModal = function () {
            //result is the CropDataViewModel
            learningPathResource.getCropData({ number: vm.number }, function (result) {
                var modalInstance = cropPictureService.changePicture(result, {
                    jcrop: {
                        bgColor: '#fff',
                        minSize: [177, 100],
                        maxWidth: 570,
                        maxHeight: 600,
                        boxWidth: 570,
                        boxHeight: 320,
                        aspectRatio: 16 / 9
                    }
                });
                //picuteData is the result from the closing the cropping model
                //picureData.cropData = CropDataBindingModel
                modalInstance.result.then(function (pictureData) {
                    pictureData.number = vm.number;
                    vm.loadingPicture = true;
                    learningPathResource.savePicture(pictureData, function (result) {
                        if (pictureData.cropData.tempFolderGuid !== undefined)
                            cropPictureService.removeTempFolder(pictureData.cropData.tempFolderGuid);
                        messageService.success("common.cropPictureModal.pictureSaved");
                        vm.learningPathVersion.hasPicture = result.value !== null;
                        vm.learningPathVersion.pictureUrl = result.value;
                        vm.loadingPicture = false;
                    }, function (error) {
                        vm.loadingPicture = false;
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            }, function (error) {
                messageService.error(error);
            });
        };
        vm.openPathAccessExpiryModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/learningPaths/modals/editPathAccessExpiryModalView.html",
                controller: "EditPathAccessExpiryModalCtrl as vm",
                size: "lg",
                resolve: {
                    model: function () {
                        return {
                            pathAccessExpires: vm.learningPathVersion.pathAccessExpires,
                            pathAccessExpiryType: vm.learningPathVersion.pathAccessExpiryType,
                            accessExpireYears: vm.learningPathVersion.accessExpireYears,
                            accessExpireMonths: vm.learningPathVersion.accessExpireMonths,
                            accessExpireDays: vm.learningPathVersion.accessExpireDays,
                            sendAccessExpiringNotification: vm.learningPathVersion.sendAccessExpiringNotification,
                            sendAccessExpiredNotification: vm.learningPathVersion.sendAccessExpiredNotification,
                            accessExpiringNotificationInterval: vm.learningPathVersion.accessExpiringNotificationInterval,
                            accessExpiringNotificationDays: vm.learningPathVersion.accessExpiringNotificationDays
                        };
                    },
                    loadCtrl: ["$ocLazyLoad", function ($ocLazyLoad) {
                            return import(
                            /* webpackChunkName: "editPathAccessExpiryModal" */
                            "../modals/editPathAccessExpiryModalCtrl").then(function (mod) { return $ocLazyLoad.load(mod.EditPathAccessExpiryModal); });
                        }]
                },
            });
            modalInstance.result.then(function (result) {
                learningPathVersionResource.saveAccessExpires({ id: vm.learningPathVersion.id }, result, function () {
                    angular.extend(vm.learningPathVersion, result);
                    messageService.success("common.changesSaved");
                }, function (error) {
                    messageService.error(error);
                });
            }).catch(angular.noop);
        };
        vm.openPathExpiryModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/learningPaths/modals/editPathExpiryModalView.html",
                controller: "EditPathExpiryModalCtrl as vm",
                size: "lg",
                resolve: {
                    model: function () {
                        return {
                            expireYears: vm.learningPathVersion.expireYears,
                            expireMonths: vm.learningPathVersion.expireMonths,
                            expireDays: vm.learningPathVersion.expireDays,
                            requalifyDays: vm.learningPathVersion.requalifyDays,
                            sendExpiringNotification: vm.learningPathVersion.sendExpiringNotification,
                            sendExpiredNotification: vm.learningPathVersion.sendExpiredNotification,
                            expiringNotificationInterval: vm.learningPathVersion.expiringNotificationInterval
                        };
                    }
                }
            });
            modalInstance.result.then(function (result) {
                learningPathVersionResource.saveExpiresDuration({ id: vm.learningPathVersion.id }, result, function () {
                    angular.extend(vm.learningPathVersion, result);
                    messageService.success("common.changesSaved");
                }, function (error) {
                    messageService.error(error);
                });
            }).catch(angular.noop);
        };
        vm.openCertificateModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/learningPaths/modals/editCertificateModalView.html",
                controller: "EditCertificateModalCtrl as vm",
                size: "lg",
                resolve: {
                    data: function () {
                        return { version: vm.version };
                    }
                }
            });
            modalInstance.result.then(function (result) {
                var item = _.find(result.learningPathVersionLocalizations, function (pathVersionLocalization) {
                    return pathVersionLocalization.localizationId.toString() === $localStorage.currentLocalizationId.toString();
                });
                vm.learningPathVersion.certificate = item.certificate;
            }).catch(angular.noop);
        };
        vm.openCECreditsModal = function () {
            var data = {
                id: vm.learningPathVersion.id,
                isCECreditsEnabled: vm.learningPathVersion.isCECreditsEnabled,
                ceCreditHours: vm.learningPathVersion.ceCreditHours,
            };
            var modal = $uibModal.open({
                component: "changeCECreditsModal",
                resolve: {
                    data: function () {
                        return data;
                    },
                    loadComponent: ["$ocLazyLoad", function ($ocLazyLoad) {
                            return import(
                            /* webpackChunkName: "changeCECreditsModal" */
                            "../modals/changeCECreditsModal.component").then(function (mod) { return $ocLazyLoad.load(mod.changeCECreditsModal); });
                        }]
                }
            });
            modal.result.then(function (model) {
                console.log(model);
                vm.learningPathVersion.isCECreditsEnabled = model.isCECreditsEnabled;
                vm.learningPathVersion.ceCreditHours = model.ceCreditHours;
            }).catch(angular.noop);
        };
        vm.clearItems = function () {
            vm.learningPathVersion.items = [];
        };
        vm.newVersion = function () {
            vm.isNewVersion = true;
            learningPathVersionViewModelResource.get({ number: vm.number, version: vm.version }, function (data) {
                delete data.id;
                delete data.versionId;
                delete data.version;
                loadData(data);
                data.assignedCount = 0;
                vm.isReadOnly = false;
                vm.learningPathName = vm.learningPathVersion.learningPathName + " (" + $translate.instant("learningPath.version.newVersion") + ")";
                vm.learningPathVersion.isPublished = false;
            });
        };
        vm.isDirty = function () {
            return vm.isNewVersion ||
                !_.isEqual(angular.copy(vm.learningPathVersion.items), vm.pristineItems) ||
                vm.isInformationEnabledOriginal !== vm.learningPathVersion.isInformationEnabled;
        };
        function recalculateOrder(list) {
            return _.map(list, function (item, key) {
                item.order = key + 1;
                return item;
            });
        }
        //Publish and Unpublish
        //Save and Publish button should be disabled if there are
        //no learning items or there are no required for recognition items
        vm.updateCanPublish = function () {
            //console.log("updateCanPublish");
            var requiredForRecog = _.find(vm.learningPathVersion.items, { requiredForRecognition: true });
            if (requiredForRecog)
                vm.canPublish = true;
            else
                vm.canPublish = false;
        };
        vm.onChangeIsPublished = function (value) {
            if (value) {
                vm.publish();
            }
            else
                vm.unPublish();
        };
        vm.publish = function () {
            if (vm.isDirty()) {
                vm.save(true);
            }
            else {
                learningPathVersionResource.publish({ id: vm.learningPathVersion.id }, function () {
                    vm.isReadOnly = true;
                    messageService.success("learningPath.pathPublishedSuccessfully");
                    vm.learningPathVersion.isPublished = true;
                }, function () {
                    messageService.error("common.genericError");
                });
            }
        };
        vm.unPublish = function () {
            learningPathVersionResource.unpublish({ id: vm.learningPathVersion.id }, function () {
                vm.isReadOnly = vm.learningPathVersion.assignedCount > 0;
                messageService.success("learningPath.pathUnPublishedSuccessfully");
                vm.learningPathVersion.isPublished = false;
            }, function () {
                messageService.error("common.genericError");
            });
        };
        vm.onChangeIsReassignEnabled = function (newValue) {
            learningPathVersionResource.saveIsReassignEnabled({ id: vm.learningPathVersion.id }, { value: newValue }, function () {
                messageService.success("common.recordSaved");
            }, function () {
                messageService.error("common.genericError");
            });
        };
        vm.manageStorefront = function () {
            $state.go("main.learningItems.learningPathVersionStorefront.information", { number: vm.number, version: vm.version });
        };
        vm.manageOpenBadges = function () {
            $state.go("main.learningItems.learningPathVersionOpenBadges", { number: vm.number, version: vm.version });
        };
        vm.editProduct = function () {
            $state.go("main.catalog.productsItem", { slug: vm.learningPathVersion.slug });
        };
        vm.createProduct = function () {
            if (vm.creatingProduct)
                return;
            vm.creatingProduct = true;
            learningPathResource.createProduct({ number: vm.number }, {}, function (result) {
                if (result.slug) {
                    $state.go("main.catalog.productsItem", { slug: result.slug });
                }
                else {
                    messageService.error("common.genericError");
                    vm.creatingProduct = false;
                }
            }, function () {
                messageService.error("common.genericError");
                vm.creatingProduct = false;
            });
        };
        vm.save = function (publish) {
            vm.learningPathVersion.items = vm.learningPathVersion.items;
            vm.learningPathVersion.publish = publish;
            learningPathVersionResource.save(vm.learningPathVersion, function (data) {
                var template = "learningPath.version.saved";
                if (publish)
                    template += "AndPublished";
                messageService.success(template);
                vm.isReadOnly = vm.learningPathVersion.assignedCount > 0 || data.isPublished;
                if (vm.isNewVersion)
                    $state.go("main.learningItems.learningPathVersion", { number: data.learningPathNumber, version: data.version });
                else
                    loadData(data);
            }, function () {
                messageService.error("common.genericError");
            });
        };
        vm.editInformationItem = function () {
            $rootScope.$broadcast("toggleInfomationItemEdit", vm.learningPathVersion);
        };
        vm.toggleInformationEnabled = function () {
            vm.learningPathVersion.isInformationEnabled = !vm.learningPathVersion.isInformationEnabled;
            //Save on toggle when not new version
            if (!vm.isNewVersion) {
                learningPathVersionResource.saveIsInformationEnabled({ id: vm.learningPathVersion.id }, vm.learningPathVersion, function () {
                    if (vm.learningPathVersion.isInformationEnabled)
                        messageService.success("common.enabled");
                    else
                        messageService.success("common.disabled");
                }, function (errorData) {
                    messageService.error(errorData);
                });
            }
        };
        vm.switchHasCertificate = function (value) {
            vm.learningPathVersion.hasCertificate = value;
            //Save on toggle when not new version
            if (!vm.isNewVersion) {
                learningPathVersionResource.saveHasCertificate({ id: vm.learningPathVersion.id }, { value: vm.learningPathVersion.hasCertificate }, function () {
                }, function (error) {
                    messageService.error(error);
                });
            }
        };
        vm.setActiveVersion = function () {
            learningPathVersionResource.setActiveVersion({ id: vm.learningPathVersion.id }, function () {
                vm.learningPathVersion.activeVersion = vm.version;
                vm.learningPathVersion.isStorefrontEnabled = true;
                messageService.success("common.changesSaved");
            }, function () {
                messageService.error("common.genericError");
            });
        };
    }
}());
